/**
 * FWの共通的な設定を行う
 * @param {ng.IModule} angularModule AngularJSのモジュール
 */
export function config($httpProvider: ng.IHttpProvider): void {
    // Httpヘッダーにno-cacheを追加
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/framework/config.ts
 **/